import axios from 'axios';
import store from '../frontend/store/index';
import {mapActions} from 'vuex';
import {LOADER_NAMESPACE, LOADER_START_ACTION, LOADER_STOP_ACTION} from '../frontend/store/modules/loader';

/**
 * Loader service
 *
 * @var {Object}
 */
const loaderActions = {
    /**
     * Vuex store instance
     *
     * @var {Object}
     */
    $store: store,
    /**
     * Loader actions from vuex store
     *
     * @var {Function}
     */
    ...mapActions(LOADER_NAMESPACE, [
        LOADER_START_ACTION,
        LOADER_STOP_ACTION
    ])
};

/**
 * Intercept requests before they are handled
 *
 * @param {function} - Before request handler
 * @param {function} - Request error handler
 *
 * @return {int} - Interceptor id
 */
axios.interceptors.request.use(
    config => {
        loaderActions[LOADER_START_ACTION](config.url);
        return config;
    },
    error => {
        loaderActions[LOADER_STOP_ACTION](error.config.url);
        return Promise.reject(error);
    }
);

/**
 * Intercept responses before they are handled
 *
 * @param {function} - Before response handler
 * @param {function} - Request error handler
 *
 * @return {int} - Interceptor id
 */
axios.interceptors.response.use(
    response => {
        loaderActions[LOADER_STOP_ACTION](response.config.url);
        return response;
    },
    error => {
        loaderActions[LOADER_STOP_ACTION](error.config.url);
        return Promise.reject(error);
    }
);